import React from 'react';

import { Link } from 'expo-router';
import { useIntl } from 'react-intl';
import { Text, View } from 'react-native';

import { routes } from 'utils/routing';

export const DeliveryTerms = () => {
  const { formatMessage } = useIntl();

  return (
    <View style={{ alignItems: 'center', justifyContent: 'center', paddingHorizontal: 16 }}>
      <Text style={{ textAlign: 'center', lineHeight: 20 }}>
        {formatMessage({
          id: 'deliveryTermsPrefix',
          defaultMessage:
            'Delivery terms and fees apply. Prices may be higher than at restaurants. ',
        })}
        <Link href={routes.deliveryTerms}>
          <Text style={{ textDecorationLine: 'underline', color: '#000' }}>
            {formatMessage({
              id: 'clickHereForDetails',
              defaultMessage: 'Click here for details.',
            })}
          </Text>
        </Link>
      </Text>
    </View>
  );
};
